"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.build_data = void 0;
exports.build_data = { "build_version": "2.26.0", "build_date": "2021-03-05T20:14:47.107Z", "build_branch": "staging", "build_commit": "a815f58869adc00c205edd99832349b155bf937d" };
